<template>
    <v-card style="padding: 5px 10px">
        <slot name="close" />
        <v-toolbar color="#f9f9f9" flat>
            <div class="v-toolbar-content-container">
                <v-spacer />
                <slot name="select" />
                <div class="v-toolbar-content-input">
                    <v-text-field
                            v-model="searchValue"
                            append-icon="search"
                            label="请输入关键字查询"
                            single-line
                            hide-details
                    />
                </div>
            </div>
        </v-toolbar>

        <v-divider />
        <v-data-table
                :items="categories"
                :headers="headers"
                class="elevation-1"
                :must-sort="false"
                hide-actions
                :pagination.sync="pagination"
        >
            <template v-slot:headers="props">
                <tr class="job-title-tr">
                    <th
                            :class="cateChooseInfo.choice.first != '' ? 'active-choice' : ''"
                            style="cursor:pointer"
                            @click="cateDialog('firstList', 'first')"
                    >
                        {{ props.headers[0]['text']}}
                        <v-icon small>dialpad</v-icon>
                    </th>
                    <th
                            :class="cateChooseInfo.choice.second != '' ? 'active-choice' : ''"
                            style="cursor:pointer"
                            @click="cateDialog('secondList', 'second')"
                    >
                        {{ props.headers[1]['text']}}
                        <v-icon small>dialpad</v-icon>
                    </th>
                    <th>
                        {{ props.headers[2]['text']}}
                    </th>
                    <th>
                        {{ props.headers[3]['text']}}
                    </th>
                    <th>
                        {{ props.headers[4]['text']}}
                    </th>
                </tr>
            </template>
            <template v-slot:items="props">
                <tr>
                    <td>{{ props.item.first.name}}</td>
                    <td>{{ props.item.second.name}}</td>
                    <td>{{ props.item.level}}</td>
                    <td>{{ props.item.code}}</td>
                    <td>{{ props.item.name}}</td>
                </tr>
            </template>
        </v-data-table>
        <div class="text-xs-center pt-2">
            <v-pagination v-model="pagination.page" :length="pages" :total-visible="7"></v-pagination>
        </div>
        <v-dialog v-model="categoryDialogVisible" max-width="800px" class="category-dialog">
            <v-toolbar color="#f9f9f9" flat>
                <v-toolbar-title>{{ headers[cateChooseInfo.currentMap[cateChooseInfo.choice.currentKey]]['text']
                    }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn icon @click="closeCateDialog">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <div class="category-button-container">
                <template v-for="categoryValue in cateChooseInfo.categoryListMap" >
                    <div class="category-button" :key="categoryValue.id">
                        <v-btn
                                depressed
                                @click="choiceCate(categoryValue)"
                                :color="
                                categoryValue.id ==
                                cateChooseInfo.choice[cateChooseInfo.choice.currentKey]['id']
                                || (categoryValue.id == 0 && cateChooseInfo.choice[cateChooseInfo.choice.currentKey] == '') ?'primary' : ''"
                        >{{categoryValue.name}}</v-btn>
                    </div>
                </template>
            </div>
        </v-dialog>
    </v-card>
</template>

<script>
    export default {
        props: {
            comId:{
                type:String,
                default:'1001'
            },
            // 职业类别限制到几级
            limit: Number,
            perPage: {
                type: Number,
                default: 10
            }
        },
        data(){
            return {
                categoryLists:[],
                categoryId: 0,
                searchValue: "",
                //分类查找
                cateChooseInfo: {
                    firstList: [],//大类标签列表
                    secondList: [],//细分行业列表
                    categoryListMap: [],//当前选择的所有标签集合
                    //当前选项
                    choice: {
                        first: "",
                        second: "",
                        currentKey: "first",
                    },
                    currentMap: {
                        first: 0, second: 1
                    }
                },
                headers:[
                    {text : "大类行业", value : "first.name", sortable: false},
                    {text : "细分行业", value : "second.name",sortable: false},
                    {text : "职业类别", value : "level",sortable: false},
                    {text : "职业代码", value : "code",sortable: false},
                    {text : "职业名称", value : "name",sortable: false},
                ],
                pagination: {rowsPerPage: this.perPage},
                categoryDialogVisible: false,
            }
        },
        computed: {
            pages () {
                if (this.pagination.rowsPerPage == null ||
                    this.pagination.totalItems == null
                ) return 0

                return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
            },
            categories() {
                if (this.$store.state.insure.comId == this.comId) {
                    let categories = this.$store.state.insure.categories;
                    let keyword = this.searchValue.trim();
                    if (this.categoryLists.length == 0 || this.categoryId != this.comId) {
                        this.setCategoryLists(categories);
                    }
                    let data = this.searchData(keyword);
                    data = this.searchCateByIds(data);
                    if (this.cateChooseInfo.firstList.length == 0 && this.cateChooseInfo.secondList.length == 0) {
                        this.setCategoryMap();
                    }
                    return data;
                }else{
                    return []
                }
            },
        },
        watch: {
            comId(){
                this.$store.dispatch("getCategories",this.comId);
            }
        },
        mounted() {
            this.$store.dispatch("getCategories",this.comId);
        },
        methods:{
            setCategoryLists(list){
                this.categoryId = this.comId;
                this.categoryLists = [];
                let firstObj = {};
                let secondObj = {};
                list.forEach((result)=>{
                    firstObj = this.setObj(result);
                    result.children.forEach(result2 => {
                        secondObj = this.setObj(result2);
                        result2.children.forEach(result3 => {
                            this.categoryLists.push({
                                first : firstObj,
                                second: secondObj,
                                code: result3.code,
                                id: result3.id,
                                level: result3.level == 0 ? "拒保" : result3.level,
                                name: result3.name,
                                keywords: [
                                    firstObj.name, secondObj.name,
                                    result3.name, result3.code
                                ]
                            })
                        })
                    })
                });
            },
            setObj(result){
                return {
                    code : result.code,
                    id   : result.id,
                    name : result.name,
                }
            },
            searchData(keyword){
                if (!keyword){
                    return this.categoryLists;
                }
                //keyword = this.ignoreKeyword(keyword)
                let data = [];
                this.categoryLists.map(result => {
                    let is_true = false;
                    //循环判断是否有关键字
                    for (let kk in result.keywords){
                        let reg = new RegExp(keyword, 'g');
                        if (reg.test(result.keywords[kk])){
                            is_true = true;
                            break;
                        }
                    }
                    if (is_true){
                        data.push(result);
                    }
                });
                return data;
            },
            setCategoryMap(){
                this.cateChooseInfo.firstList = [];
                this.cateChooseInfo.secondList = [];
                let firstIds=[],secondIds = [];
                if(this.categoryLists.length > 0){
                    this.cateChooseInfo.firstList.push({id : 0, name: "全部", code: 0});
                    this.cateChooseInfo.secondList.push({id : 0, name: "全部", code: 0});
                }
                for (let kk in this.categoryLists) {
                    if(firstIds.indexOf(this.categoryLists[kk]['first']['id']) == -1){
                        this.cateChooseInfo.firstList.push(this.categoryLists[kk]['first']);
                        firstIds.push(this.categoryLists[kk]['first']['id']);
                    }
                    if (this.cateChooseInfo.choice.first != ''){
                        if (this.categoryLists[kk]['first']['id'] != this.cateChooseInfo.choice.first.id){
                            continue;
                        }
                    }
                    if(secondIds.indexOf(this.categoryLists[kk]['second']['id']) == -1){
                        this.cateChooseInfo.secondList.push(this.categoryLists[kk]['second']);
                        secondIds.push(this.categoryLists[kk]['second']['id']);
                    }
                }
            },
            searchCateById(data, val, key){
                let _data = [];
                data.map(result => {
                    if(result[key]['id'] == val.id){
                        _data.push(result);
                    }
                })
                return _data;
            },
            searchCateByIds(data){
                let searchList = ['first', 'second']
                for(let kk in searchList){
                    if (this.cateChooseInfo.choice[searchList[kk]] === ""){
                        continue;
                    }
                    data = this.searchCateById(data, this.cateChooseInfo.choice[searchList[kk]], searchList[kk]);
                }
                this.pagination.totalItems = data.length;
                return data;
            },
            choiceCate(value){
               // this.cateChooseInfo.choice.second = "";
                if (this.cateChooseInfo.choice.currentKey === 'first'){
                    this.cateChooseInfo.choice.second = "";
                }
                if(value.id === 0){
                    if (this.cateChooseInfo.choice.currentKey === 'first'){
                        this.cateChooseInfo.choice.first = "";
                    }
                    this.cateChooseInfo.choice.second = "";
                }else{
                    if (this.cateChooseInfo.choice[this.cateChooseInfo.choice.currentKey] != ""){
                        this.cateChooseInfo.choice[this.cateChooseInfo.choice.currentKey]['id'] == value.id ?
                            this.cateChooseInfo.choice[this.cateChooseInfo.choice.currentKey] = "" :
                            this.cateChooseInfo.choice[this.cateChooseInfo.choice.currentKey] = value;
                    }else {
                        this.cateChooseInfo.choice[this.cateChooseInfo.choice.currentKey] = value;
                    }
                }
                this.setCategoryMap();
                this.categoryDialogVisible = false;
            },
            cateDialog(propsName, currentKey){
                this.cateChooseInfo.choice.currentKey = currentKey;
                this.cateChooseInfo.categoryListMap = this.cateChooseInfo[propsName];
                this.categoryDialogVisible = true;
            },
            closeCateDialog(){
                this.categoryDialogVisible = false;
            },
            //忽略的关键字
            ignoreKeyword(keyword){
                let exp = [
                    "\\s+"
                ]
                let regExp;
                for(let i in exp){
                    regExp = new RegExp(exp[i]);
                    if(regExp.test(keyword)){
                        keyword = keyword.replace(regExp, "");
                    }
                }
                return keyword;
            }
        },

    }
</script>

<style lang="scss" scoped>
    table.v-table thead th,table.v-table tbody td{
        padding: 0 0.5rem
    }
    .job-title-tr {
        th{
            text-align: left;
        }
        th.active-choice{
            color: #dd122a !important;
            i {
                color: #dd122a !important;
            }
        }
    }
    .category-dialog{
        background-color: #fff;
    }
    .category-button-container{
        position: relative;
        div.category-button{
            float: left;
            margin: 2px 2px;
        }
    }
    div.v-toolbar-content-container{
        width: 100%;
        position: relative;
        height: 100%;
        div.v-toolbar-content-input{
            width: 50%;
            position: absolute;
            right: 1px;
            bottom: 8px
        }
    }
</style>
